export enum WebinarType {
  LIVE_STREAM = 'live_stream',
  SAVED_WEBINAR = 'saved_webinar',
  EVENT = 'event',
  NO_REGISTER = 'no_register',
  REGISTER_UNTIL_START = 'register_until_start',
}
